module.exports = __webpack_public_path__ + "static/media/career-profile1.0d4b7c4d.png";